import React, { useRef } from "react";
import {  FaCalendarAlt, FaInfinity, FaCheckCircle } from "react-icons/fa";
import MonoButton from "../../kits/DesignKit/MonoButton";
import RoughBorder from "../../kits/LayoutKit/RoughBorder";

const ZenPostDocStudioPriceCards = ({
  id = "docstudio-pricing",
  badge = "Doc Studio Add-on",
  title = "Doc Studio freischalten",
  subtitle = "Buchbar in Free oder Pro. Kein Bundle-Zwang.",
  subtitle2 = "7 Tage Testzugang ohne Anmeldung",
  plans = null,
  highlight = "yearly", // "monthly" | "yearly" | "lifetime"
  onSelect = null, // (plan) => void
  theme = "dark",
}) => {
  const isDark = theme === "dark";

  const refs = [useRef(null), useRef(null), useRef(null)];

  const defaultPlans = [
    {
      key: "monthly",
      label: "Monatlich",
      price: "9,99€",
      suffix: "pro Monat",
      note: "Flexibel kündbar",
      icon: <FaCalendarAlt />,
      benefits: [
        "Doc Studio freischalten",
        "Project Context Wizard",
        "Project Scan + Struktur",
        "README / Docs / Data Room",
      ],
    },
  
    {
      key: "lifetime",
      label: "Lifetime",
      price: "79€",
      suffix: "einmalig",
      note: "Für immer",
      icon: <FaInfinity />,
      benefits: [
        "Doc Studio freischalten",
        "Doc Themen Templates",
        "Keine Folgekosten",
        "Hard Scan mit KI",
      ],
    },
  ];

  const list = plans || defaultPlans;

  const Card = ({ plan, idx }) => {
    const isHot = plan.key === highlight;
    const parentRef = refs[idx];

    return (
      <div ref={parentRef} className="relative h-full">
        <div
          className={[
            "relative overflow-hidden rounded-2xl border p-6 sm:p-8 h-full flex flex-col",
            isDark ? "border-brand  shadow-lg shadow-slate-950/40" : "border-brand bg-white",
            isHot ? "shadow-brand/30" : "",
          ].join(" ")}
        >
          {/* Badge */}
          {isHot && (
            <div className="absolute right-6 top-6 rounded-full  px-3 py-1 text-xs font-semibold border border-brand text-[#EFEBDC]">
              Empfohlen
            </div>
          )}

          {/* Icon */}
          <div className="mb-4">
            <div className="flex h-12 w-12 items-center justify-center rounded-xl border border-brand text-brand text-xl">
              {plan.icon}
            </div>
          </div>

          {/* Title */}
          <h3 className="text-xl sm:text-2xl font-extrabold text-[#EFEBDC] mb-2">
            {plan.label}
          </h3>

          {/* Price */}
          <div className="mb-3">
            <span className="text-4xl sm:text-5xl font-extrabold text-[#EFEBDC]">
              {plan.price}
            </span>
            <div className="mt-1 text-xs sm:text-sm text-[#EFEBDC]/90">
              {plan.suffix}
              {plan.note ? <span className="ml-2 text-brand">· {plan.note}</span> : null}
            </div>
          </div>

          {/* Benefits */}
          <ul className="mt-4 space-y-2 sm:space-y-3 mb-6">
            {plan.benefits.map((b, i) => (
              <li key={i} className="flex items-start gap-2 text-xs sm:text-sm text-amber-50">
                <FaCheckCircle className="text-brand flex-shrink-0 mt-0.5" />
                <span>{b}</span>
              </li>
            ))}
          </ul>

          {/* CTA */}
          <div className="mt-3">
            <MonoButton
              onClick={() => onSelect?.(plan)}
              className={[
                "rounded-full border-brand px-6 py-3 text-sm sm:text-base  shadow-lg transition w-full",
                isHot
                  ? "bg-transparent text-brand shadow-brand/40 hover:shadow-brand/60"
                  : "bg-transparent text-[#EFEBDC] shadow-slate-950/40 hover:shadow-slate-950/60",
              ].join(" ")}
              underlineColors="ZenBrand"
              textColor={isHot ? "text-brand" : "text-[#EFEBDC]"}
            >
              {isHot ? "Auswählen" : "Jetzt kostenfrei testen"}
            </MonoButton>
          </div>
        </div>

        {/* Rough Border (optional – nur wenn du RoughBorder hier willst) */}
        {!isDark && (
          <RoughBorder
            parentRef={parentRef}
            radius={10}
            padding={2}
            color="#AC8E66"
            strokeWidth={isHot ? 0.4 : 0.3}
            roughness={1}
            bowing={2}
          />
        )}
      </div>
    );
  };

  return (
    <section id={id} className="py-16 sm:py-20 px-4">
      <div className="max-w-6xl mx-auto text-center">
        <div className="inline-flex items-center rounded-full border border-brand px-3 py-1 text-xs text-[#EFEBDC]">
          {badge}
        </div>

        <h2 className="mt-4 text-3xl sm:text-4xl md:text-5xl font-extrabold text-brand">
          {title}
        </h2>

        <p className="mt-3 text-base sm:text-lg text-[#EFEBDC] max-w-3xl mx-auto">
          {subtitle}
        </p>

          <p className="mt-3 text-base sm:text-lg text-[#EFEBDC] max-w-3xl mx-auto">
          {subtitle2}
        </p>

        <div className="mt-10 grid grid-cols-1 gap-5 md:grid-cols-2 text-left">
          {list.map((plan, idx) => (
            <Card key={plan.key} plan={plan} idx={idx} />
          ))}
        </div>
      </div>
    </section>
  );
};

export default ZenPostDocStudioPriceCards;
